export const validation = {
  question: "Question is required",
  validQuestion: "Please enter valid Question",
  typeOfFaqs: "Type Of faqs is required",
  answer: "Answer is required",
  minPhone: "Phone number must be 6 to 16 digits",
  phoneNumber: "phone number is required",
  addressReq: "Address is required",
  emailReq: "Email is required",
  termsAndConditions: "Terms and Conditions is required",
  privacyPolicy: "Privacy Policy is required",
  metaTitle: "Title is required",
  enterContent: "Content is required",
  content: "Content is required",
  reply: "Reply message is required",
};
